import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AgeVerification from "./AgeVerification";
import Navbar from "./Navbar";
import FooterSection from "./FooterSection";

interface PageLayoutProps {
  children: React.ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  const [verified, setVerified] = useState(() => {
    return sessionStorage.getItem("age_verified") === "true";
  });
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!verified && sessionStorage.getItem("age_verified") !== "true") {
      // not verified yet, AgeVerification will show
    }
  }, [verified]);

  const handleVerified = () => {
    setVerified(true);
  };

  return (
    <>
      <AgeVerification onVerified={handleVerified} />
      {verified && (
        <div className="min-h-screen bg-white flex flex-col">
          <Navbar />
          <main className="flex-1 pt-16 md:pt-20">
            {children}
          </main>
          <FooterSection />
        </div>
      )}
    </>
  );
}
